import { Routes } from '@angular/router';

import { authGuard, autorizacionGuard, invitadoGuard } from './core/guards/auth.guards';
import { Objeto, Permiso } from './core/models/auth.models';

export const routes: Routes = [
  // Pública a propósito: las tiendas exigen que la política sea accesible sin
  // iniciar sesión, y Google Play la revisa por la ubicación en segundo plano.
  {
    path: 'privacidad',
    loadComponent: () =>
      import('./features/privacidad/privacidad').then((m) => m.PrivacidadComponent),
    title: 'Política de privacidad · Dietrans',
  },
  {
    path: 'login',
    canActivate: [invitadoGuard],
    loadComponent: () => import('./features/login/login').then((m) => m.LoginComponent),
    title: 'Ingresar · Dietrans',
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () => import('./layout/shell/shell').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/home').then((m) => m.HomeComponent),
        title: 'Inicio · Dietrans',
      },

      // Recogidas
      {
        path: 'recogidas/solicitar',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.RECOGIDA]: [Permiso.CREAR] } } },
        loadComponent: () =>
          import('./features/recogidas/solicitar/solicitar-recogida').then(
            (m) => m.SolicitarRecogidaComponent,
          ),
        title: 'Solicitar recogida · Dietrans',
      },
      {
        path: 'recogidas/:id',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.RECOGIDA]: [Permiso.VER] } } },
        loadComponent: () =>
          import('./features/recogidas/detalle/recogida-detalle').then(
            (m) => m.RecogidaDetalleComponent,
          ),
        title: 'Recogida · Dietrans',
      },
      {
        path: 'recogidas',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.RECOGIDA]: [Permiso.VER_MASIVO] } } },
        loadComponent: () =>
          import('./features/recogidas/recogidas').then((m) => m.RecogidasComponent),
        title: 'Recogidas · Dietrans',
      },

      // Paquetes
      {
        path: 'paquetes/:id',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.PAQUETE]: [Permiso.VER] } } },
        loadComponent: () =>
          import('./features/paquetes/detalle/paquete-detalle').then(
            (m) => m.PaqueteDetalleComponent,
          ),
        title: 'Paquete · Dietrans',
      },
      {
        path: 'paquetes',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.PAQUETE]: [Permiso.VER_MASIVO] } } },
        loadComponent: () =>
          import('./features/paquetes/paquetes').then((m) => m.PaquetesComponent),
        title: 'Paquetes · Dietrans',
      },

      // Rutas
      {
        path: 'rutas/crear',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.RUTA]: [Permiso.CREAR] } } },
        loadComponent: () =>
          import('./features/rutas/crear/crear-rutas').then((m) => m.CrearRutasComponent),
        title: 'Crear rutas · Dietrans',
      },
      {
        path: 'rutas/:id',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.RUTA]: [Permiso.VER] } } },
        loadComponent: () =>
          import('./features/rutas/detalle/ruta-detalle').then((m) => m.RutaDetalleComponent),
        title: 'Ruta · Dietrans',
      },
      {
        path: 'rutas',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.RUTA]: [Permiso.VER_MASIVO] } } },
        loadComponent: () => import('./features/rutas/rutas').then((m) => m.RutasComponent),
        title: 'Rutas · Dietrans',
      },

      // Entregas
      {
        path: 'entregas/:id',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.ENTREGA]: [Permiso.VER] } } },
        loadComponent: () =>
          import('./features/entregas/detalle/entrega-detalle').then(
            (m) => m.EntregaDetalleComponent,
          ),
        title: 'Entrega · Dietrans',
      },
      {
        path: 'entregas',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.ENTREGA]: [Permiso.VER_MASIVO] } } },
        loadComponent: () =>
          import('./features/entregas/entregas').then((m) => m.EntregasComponent),
        title: 'Entregas · Dietrans',
      },

      // Reportes
      {
        path: 'reportes',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.PAQUETE]: [Permiso.VER_MASIVO] } } },
        loadComponent: () =>
          import('./features/reportes/reportes').then((m) => m.ReportesComponent),
        title: 'Reportes · Dietrans',
      },

      // Inventario
      {
        path: 'inventario',
        canActivate: [autorizacionGuard],
        data: { autorizacion: { permisos: { [Objeto.PAQUETE]: [Permiso.VER_MASIVO] } } },
        loadComponent: () =>
          import('./features/inventario/inventario').then((m) => m.InventarioComponent),
        title: 'Inventario · Dietrans',
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
